<template>
  <div class="step step--career-interest">
    <button-back @back="back"></button-back>
    <div class="text-center">
      <div align-h="center">
        <h2>How about something you’re good at?</h2>
        <p>Select a skill from the list to help narrow down a possible career path.</p>
      </div>
      <div align-h="center" :class="[user.skills.length >= 1 ? 'disable' : '', 'step__career-options']">
        <div class="styled-checkbox button-radio" v-for="(skill, index) in skills" v-bind:key="index">
          <input type="checkbox" :id="'skill-' + index" :value="skill" v-model="user.skills">
          <label :for="'skill-' + index">{{ sentenceCaseSkill(skill) }}</label>
        </div>
      </div>
      <div class="step__buttons">
        <b-button v-on:click="submit" variant="primary" block :disabled="user.skills.length < 1">Continue</b-button>
      </div>
      <div class="text-left no-gutters" align-h="center">
        <disclaimer />
      </div>
    </div>
  </div>
</template>

<script>
import ButtonBack from '../buttons/Back.vue'
import Disclaimer from '../Disclaimer.vue'
import skillDegrees from './../../data/skills.json';

export default {
  name: 'CareerInterestStep',
  props: {
    user: Object
  },
  data () {
    return {
      skills: skillDegrees.map((sd) => sd.skill.trim()).filter((v, i, a) => a.indexOf(v) === i).sort(),
    }
  },
  components: {
    ButtonBack,
    Disclaimer
  },
  methods: {
    back: function () {
      this.$emit('back');
    },
    submit: function () {
      this.$emit('completed');
    },
    sentenceCaseSkill(skill) {
      const [firstLetter, ...rest] = skill.split('');
      return firstLetter.toUpperCase() + rest.join('').toLowerCase();
    }
  }
}
</script>

<style scoped>
</style>
